import { useEffect, useRef } from "react";
import { motion } from "framer-motion";

import SocialPostCard from "./SocialPostCard";

export default function ThreadList({

    posts = [],

    loading,

    hasMore,

    loadMore,

    onLike,

    onComment,

    onShare,

    onBookmark,

    onOpen

}) {

    const observerRef = useRef(null);

    useEffect(() => {

        if (!hasMore || loading) return;

        const observer = new IntersectionObserver(

            (entries) => {

                if (entries[0].isIntersecting) {

                    loadMore?.();

                }

            },

            {

                threshold: 0.2,

            }

        );

        if (observerRef.current) {

            observer.observe(observerRef.current);

        }

        return () => observer.disconnect();

    }, [loading, hasMore]);

    if (!loading && posts.length === 0) {

        return <EmptyFeed />;

    }

    return (

        <div className="space-y-8">

            {

                posts.map((post) => (

                    <motion.div

                        key={post.id}

                        layout

                    >

                        <SocialPostCard

                            post={post}

                            onLike={onLike}

                            onComment={onComment}

                            onShare={onShare}

                            onBookmark={onBookmark}

                            onOpen={onOpen}

                        />

                    </motion.div>

                ))

            }

            {

                loading && (

                    <>

                        <PostSkeleton />

                        <PostSkeleton />

                    </>

                )

            }

            {

                hasMore && (

                    <div

                        ref={observerRef}

                        className="h-10"

                    />

                )

            }

        </div>

    );

}

function EmptyFeed() {

    return (

        <div
            className="
                rounded-[32px]
                bg-white/70
                backdrop-blur-xl
                border
                border-white/30
                shadow-xl
                py-20
                text-center
            "
        >

            <div className="text-6xl">

                💭

            </div>

            <h2
                className="
                    mt-6
                    text-2xl
                    font-bold
                "
            >

                No discussions yet

            </h2>

            <p
                className="
                    mt-3
                    text-gray-500
                "
            >

                Be the first creator to start a discussion.

            </p>

        </div>

    );

}

function PostSkeleton() {

    return (

        <div
            className="
                rounded-[32px]
                bg-white/70
                backdrop-blur-xl
                border
                border-white/30
                shadow-xl
                p-6
                animate-pulse
            "
        >

            <div className="flex gap-4">

                <div
                    className="
                        w-14
                        h-14
                        rounded-full
                        bg-gray-200
                    "
                />

                <div className="flex-1">

                    <div
                        className="
                            h-5
                            bg-gray-200
                            rounded
                            w-40
                        "
                    />

                    <div
                        className="
                            mt-3
                            h-4
                            bg-gray-200
                            rounded
                            w-24
                        "
                    />

                </div>

            </div>

            <div
                className="
                    mt-8
                    h-5
                    bg-gray-200
                    rounded
                "
            />

            <div
                className="
                    mt-4
                    h-5
                    bg-gray-200
                    rounded
                    w-10/12
                "
            />

            <div
                className="
                    mt-4
                    h-80
                    rounded-3xl
                    bg-gray-200
                "
            />

        </div>

    );

}